import styles from './index.module.sass'
import { Icon } from '../Icon'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import expendfilter from '../../../assets/expend.svg'

export const Search = () => {
    const navigate = useNavigate()
    const [searchQuery, setSearchQuery] = useState('')
    function handleSearch() {
        navigate('/search-results/' + searchQuery)
    }
    return (
        <div className={styles.searchBlock}>
            <div className={styles.filtercontainer}>
                <h1 className={styles.filterfont20}>All Filters</h1>
                <button>
                    <img src={expendfilter} alt="expendfilter" />
                </button>
            </div>
            <input
                value={searchQuery}
                onChange={(e) => {
                    setSearchQuery(e.target.value)
                }}
                className={styles.input}
                type="text"
                placeholder="Search by Address / Txn Hash / Block / Token / Domain Name"
            />
            <div>
                <button className={styles.search} onClick={handleSearch}>
                    <Icon icon={'search'} />
                </button>
            </div>
        </div>
    )
}
